// extracted by mini-css-extract-plugin
module.exports = {"table":"styles_table__3NuGT","custom-table-head-bg":"styles_custom-table-head-bg__L3D3p"};